import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isNumeric } from 'dpl/shared/form/utils';
import { pushParams, resetParams } from 'dpl/actions/query_params';
import { PAGE, RESULTS_TYPE } from 'dpl/constants/query_params';
import {
  RESULTS_TYPES,
  PUPPY_FILTERS
} from 'dpl/puppy_search_results/utils/constants';

export default function useSearchQueryFilter(queryParamName) {
  const queryParams = useSelector(state => state.queryParams);

  const dispatch = useDispatch();

  const searchQueryFilterValues = useMemo(
    () =>
      (queryParams[queryParamName] || '')
        .split(',')
        .filter(isNumeric)
        .map(Number),
    [queryParams[queryParamName]]
  );

  function toggleFilter(filterValue) {
    const newFilterIds = new Set(searchQueryFilterValues);

    newFilterIds.has(filterValue)
      ? newFilterIds.delete(filterValue)
      : newFilterIds.add(filterValue);

    if (newFilterIds.size > 0) {
      const params = { [queryParamName]: [...newFilterIds].join(',') };

      if (PUPPY_FILTERS.includes(queryParamName)) {
        params[RESULTS_TYPE] = RESULTS_TYPES.PUPPIES;
      }

      dispatch(pushParams(params, { hash: true }));
    } else {
      dispatch(resetParams(queryParamName, { hash: true }));
    }

    dispatch(resetParams(PAGE));

    return newFilterIds;
  }

  return {
    searchQueryFilterValues,
    toggleFilter
  };
}
